import { render } from "./personSeting.vue?vue&type=template&id=d4054200"
import script from "./personSeting.vue?vue&type=script&lang=js"
export * from "./personSeting.vue?vue&type=script&lang=js"

import exportComponent from "/var/jenkins_home/uat/ydd-zht-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__